// src/i18n/config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 導入翻譯文件
import enTranslation from './locales/en.json';
import zhTWTranslation from './locales/zh-TW.json';
import zhCNTranslation from './locales/zh-CN.json';

// 配置資源
const resources = {
  en: {
    translation: enTranslation
  },
  'zh-TW': {
    translation: zhTWTranslation
  },
  'zh-CN': {
    translation: zhCNTranslation
  }
};

i18n
  // 檢測用戶語言
  .use(LanguageDetector)
  // 傳遞 i18n 實例到 react-i18next
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    resources,
    fallbackLng: 'zh-TW', // 默認語言
    lng: localStorage.getItem('language') || 'zh-TW', // 從 localStorage 讀取語言偏好
    debug: false,
    
    interpolation: {
      escapeValue: false // React 已經處理了 XSS
    },
    
    detection: {
      // 語言檢測順序
      order: ['localStorage', 'navigator'],
      // 存儲到 localStorage
      caches: ['localStorage'],
      // localStorage 的 key
      lookupLocalStorage: 'language'
    }
  });

export default i18n;
